import { watchState } from "web/redux/state-watcher";
import baustein from "baustein";

function extractFilterState(state) {
    return state.feedFiltersReducer.title;
}

export default baustein.register("feed-title", {
    init() {
        watchState(extractFilterState, (title) => {
            if (title) {
                this.el.innerText = title;
            }
        });
    },
});
